module.exports = __webpack_public_path__ + "static/media/pizza-face.b9602993.mov";